import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";

import { interval, Subscription } from "rxjs";
import { map } from "rxjs/operators";

const currentTime$ = interval(3000).pipe(map(() => new Date()));

@Component({
  selector: "message-timestamp",
  // eslint-disable-next-line prettier/prettier
  template: `{{ timestamp | relativeTimeFormat: currentTime }}
`,
  host: {
    class: "ds-block ds-text-xs ds-font-light ds-opacity-70",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageTimestampComponent implements OnInit, OnDestroy {
  @Input() timestamp!: Date;

  currentTime = new Date();

  private _currentTimeSubscription = Subscription.EMPTY;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this._currentTimeSubscription = currentTime$.subscribe((currentTime) => {
      this.currentTime = currentTime;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this._currentTimeSubscription.unsubscribe();
  }
}
